import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { Caption1 } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";
import { TimeTaskView } from "~/components/ListView/columns";
import LabelItems from "~/components/ListView/columns/LabelItems";
import { getObjectTotalTime } from "~/store/selectors/selector.additionalObjectData";
import { getPersonalizedDateFormat } from "~/store/selectors/selector.configOptions";
import { getTaskById, makeIsTaskOverdueSelector } from "~/store/selectors/selector.tasks";
import { canSeeTimeEstimates } from "~/store/selectors/selector.users";
import { formatDateRange } from "~/utils/date";

const PreviewTaskItemColumns = ({ type, taskId }) => {
  const task = useSelector((state) => getTaskById(state, taskId)).toJS();
  const tracked = useSelector((state) => getObjectTotalTime(state, "Task", taskId));
  const canViewEstimate = useSelector((state) => canSeeTimeEstimates(state, task.project_id));
  const getIsTaskOverdue = useMemo(makeIsTaskOverdueSelector, []);
  const isOverdue = useSelector((state) => getIsTaskOverdue(state, task.id));
  const format = useSelector(getPersonalizedDateFormat);
  const formattedDate = formatDateRange(task.start_on, task.due_on, format);
  const estimated = task?.estimate && canViewEstimate ? Number(task?.estimate) : 0;

  return (
    <div className={classNames("tw-hidden lg:tw-flex tw-justify-end col", `col-${type.toLowerCase()}`)}>
      {type === "Time" ? (
        <TimeTaskView
          estimated={estimated}
          tracked={tracked}
          hideIcon
        />
      ) : type === "Date" ? (
        <Caption1
          weight="bold"
          className={classNames("tw-px-2", {
            "tw-text-red-alert": isOverdue,
          })}
        >
          {formattedDate}
        </Caption1>
      ) : type === "Label" ? (
        <div className="tw-flex tw-px-2">
          <LabelItems labels={task.labels} />
        </div>
      ) : null}
    </div>
  );
};

PreviewTaskItemColumns.propTypes = {
  type: PropTypes.string.isRequired,
  taskId: PropTypes.number,
};

export default PreviewTaskItemColumns;
